// =========================================================
// * Vuetify Material Dashboard - v2.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import FirebaseVue from '@/libraries/firebase'
import VueSession from 'vue-session'

import GlobalFunctions from './libraries/functions/globalFunctionsVue'

import GlobalDirectives from "./globalDirectives";

import VuetifyMoney from "vuetify-money";
import VueMask from 'v-mask'

// import DaoVue from '@/libraries/classes/DaoVue.js'
// Vue.use(DaoVue);


Vue.use(VuetifyMoney);
Vue.use(VueSession);
Vue.use(FirebaseVue);

Vue.use(GlobalDirectives);
Vue.use(GlobalFunctions);
// As a plugin

Vue.use(VueMask);

window.firebase = Vue.prototype.$firebase;

window.debug = process.env.NODE_ENV === "development" ?true:false;
//window.debug = false;

//Vue.prototype.$dao.firebase =  Vue.prototype.$firebase;


router.beforeEach((to, from, next) => {
  //console.log("before each ")
  console.log(JSON.stringify(window.uid))
  console.log(JSON.stringify(window.pid))
  
  window.user   = Vue.prototype.$session.get("user");
  window.uid   = Vue.prototype.$session.get("uid");
  window.eid   = Vue.prototype.$session.get("eid");

  //alert(`${window.eid}-${to.name}`)
  if((window.eid !== "EFZwxQvKjmt6Bn4ZlzCg")&&( (to.name == 'users')||(to.name == 'enterprises'))){
    alert("Acesso não autorizado" + to.name);
    return;
  }//Admin

  //console.log(Vue.prototype.$session.get("uid"))
  //console.log(JSON.stringify(VueSession))
  if ((!window.uid) && (to.name != 'login'))
      next({ name: "login" })
  else{
      next();
    
  }
})


Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
